"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeAndCreateI18nEntries = exports.createPropertiesI18nEntries = void 0;
var create_1 = require("./create");
Object.defineProperty(exports, "createPropertiesI18nEntries", { enumerable: true, get: function () { return create_1.createPropertiesI18nEntries; } });
Object.defineProperty(exports, "removeAndCreateI18nEntries", { enumerable: true, get: function () { return create_1.removeAndCreateI18nEntries; } });
//# sourceMappingURL=index.js.map